<template>
	<div>
		<b-breadcrumb>
			<b-breadcrumb-item :to="{ name: 'Services' }">Services</b-breadcrumb-item>
			<b-breadcrumb-item active v-if="!!error" class="text-danger"><i>Error</i></b-breadcrumb-item>
			<b-breadcrumb-item active v-else-if="loading>0" class="text-muted"><i>Loading...</i></b-breadcrumb-item>
			<b-breadcrumb-item active v-else>{{service&&service.name}}</b-breadcrumb-item>
		</b-breadcrumb>
		<b-alert :show="!!error" variant="danger">{{error}}</b-alert>
		<b-card-group v-if="!error&&service">
			<b-card no-body>
				<template #header>
					<div class="float-right">
						<b-button-group size="sm" style="margin: -10px">
							<b-dropdown v-if="authUrl" text="Auth" right variant="info">
								<b-dropdown-item @click.prevent="openAuthPopup(authUrl)" :href="authUrl">Authenticate</b-dropdown-item>
								<b-dropdown-item @click.prevent="$util.copyToClipboard(redirectUri)" :href="redirectUri">Copy Redirect URI</b-dropdown-item>
							</b-dropdown>
							<b-button @click="openEditModal(service.id)" v-b-tooltip.hover.left title="Edit service"><b-icon icon="pencil-fill"></b-icon></b-button>
							<b-button @click="openDeleteModal(service.id)" variant="danger" v-b-tooltip.hover.right.v-danger title="Delete service"><b-icon icon="trash"></b-icon></b-button>
						</b-button-group>
					</div>
					Details
				</template>
				<b-list-group flush>
					<b-list-group-item>Protocol name: <span class="float-right">{{service.protocol_name}}</span></b-list-group-item>
					<b-list-group-item>Name: <span class="float-right">{{service.name}}</span></b-list-group-item>
					<b-list-group-item v-for="(field, i) in fields" :key="i">
						{{field.label||i}}:
						<span class="float-right" v-if="field.type == 'bool'"><b-badge variant="success" v-if="service.settings[i]">true</b-badge><b-badge variant="danger" v-if="!service.settings[i]">false</b-badge></span>
						<span class="float-right" v-else-if="field.type == 'password'">******</span>
						<input class="float-right" readonly disabled v-else-if="field.type == 'color'" type="color" :value="service.settings[i]" :title="service.settings[i]">
						<span class="float-right" v-else>{{service.settings[i]}}</span>
					</b-list-group-item>
				</b-list-group>
			</b-card>
		</b-card-group>
		<b-card no-body v-if="service">
			<template #header>
				<div class="float-right">
					<b-badge v-if="service.connectionStatus" :variant="service.connectionStatus.status == 'error' ? 'danger' : ''">{{service.connectionStatus.status}}</b-badge>
				</div>
				Connection status
			</template>
			<b-table small :items="connectionStatusLog" :fields="['status','message']" class="mb-0">
				<template #cell(status)="data">
					<b-badge v-if="data.item.status" :variant="data.item.status == 'error' ? 'danger' : ''">{{data.item.status}}</b-badge>
				</template>
			</b-table>
		</b-card>
		<service-edit-modal ref="edit-modal" @saved="loadService"></service-edit-modal>
		<service-delete-modal ref="delete-modal" @deleted="loadService"></service-delete-modal>
	</div>
</template>

<script>
import ServiceEditModal from '@/components/Service/Modal/Edit.vue';
import ServiceDeleteModal from '@/components/Service/Modal/Delete.vue';

export default {
	name: 'Service',
	components: {
		ServiceEditModal,
		ServiceDeleteModal,
	},
	data() { return {
		loading: 0,
		error: null,
		service: null,
		fields: null,
		connectionStatusLog: [],
		authUrl: null,
		redirectUri: null,
	}},
	created() {
		this.loadService();
	},
	methods: {
		async loadService() {
			try {
				this.loading++;
				this.error = null;
				this.authUrl = null;
				this.redirectUri = null;
				this.service = await this.$api.get(`admin/service/${encodeURIComponent(this.$route.params.id)}`);
				this.authUrl = this.service.auth?.url;
				const proto = await this.$api.get(`admin/protocol/${encodeURIComponent(this.service.protocol_name)}`);
				this.fields = proto.serviceSettingFields;
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},
		openEditModal(id) {
			this.$refs['edit-modal'].show(id);
		},
		openDeleteModal(id) {
			this.$refs['delete-modal'].show(id);
		},
		openAuthPopup(authUrl) {
			window.open(authUrl, 'Authenticate', 'scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=500');
		},
	}
};
</script>
